import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { apiGetHomeStats } from 'services/DashboardsServices'
import { apiGetTicketList } from 'services/TicketsService'

export const getTicketsDashboard = createAsyncThunk('ticketsList/getTicketsDashboard', async (data) => {
    const response = await apiGetTicketList(data)
    return response.data
})

export const getManagementStats = createAsyncThunk('dashboardHome/getManagementStats', async () => {
    const response = await apiGetHomeStats()
    return response.data
})

const dataSlice = createSlice({
    name: 'dashboardHome/data',
    initialState: {
        ticketList: [],
        managementStats: null,
        loadingTickets: false,
        loadingManagementStats: true,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getTicketsDashboard.pending, (state) => {
                state.loadingTickets = true
            })
            .addCase(getTicketsDashboard.fulfilled, (state, action) => {
                state.ticketList = action.payload.data
                state.loadingTickets = false
            })
            .addCase(getTicketsDashboard.rejected, (state) => {
                state.loadingTickets = false
            })
            .addCase(getManagementStats.pending, (state) => {
                state.loadingManagementStats = true
            })
            .addCase(getManagementStats.fulfilled, (state, action) => {
                state.managementStats = action.payload.data
                state.loadingManagementStats = false
            })
            .addCase(getManagementStats.rejected, (state) => {
                state.loadingManagementStats = false
            })
    },
})

export default dataSlice.reducer
